(() => {
  const config = document.getElementById('steep-release-config');
  if (!config) return;
  const mode = config.dataset.mode || 'automatic';
  const launchAt = Number(config.dataset.launchAt);
  let current;
  let timer;
  const phase = () => mode === 'contest' || (mode === 'automatic' && Date.now() >= launchAt) ? 'contest' : 'kevs-only';
  const update = () => {
    const next = phase();
    document.documentElement.dataset.steepReleasePhase = next;
    document.querySelectorAll('[data-steep-release-state]').forEach(el => { el.dataset.phase = next; });
    document.querySelectorAll('[data-steep-release-label]').forEach(el => { el.textContent = next === 'contest' ? 'How You Crack' : 'Buy Kev’s Stuff'; });
    document.querySelectorAll('a[data-steep-release-home-link]').forEach(el => { el.href = '/pages/win-steep'; el.setAttribute('aria-label',next === 'contest' ? 'Enter How You Crack' : 'Buy Kev’s Stuff'); });
    document.querySelectorAll('[data-steep-release-portrait]').forEach(el => {
      const url = el.dataset.portraitUrl;
      if (url) el.src = url;
    });
    if (current && current !== next) window.dispatchEvent(new Event('steep-release-change'));
    current = next;
    clearTimeout(timer);
    if (mode === 'automatic' && Date.now() < launchAt) timer = setTimeout(update, Math.min(launchAt - Date.now() + 20, 2147483647));
  };
  update();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
})();
